import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { WrenchIcon } from '@heroicons/vue/24/outline'
import type { Service, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useService(skipLoading: boolean = false) {

    const baseForm: FormData = {
        name: null
    };

    const wrapper = new ItemWrapper<Service>("services");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const services = ref<Service[]>([]);
    const serviceOptions = ref<FormSelectOption[]>([]);

    async function addService(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading};

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        serviceOptions.value = services.value.map(service => {
            return {
                value: service.id,
                label: service.name,
                icon: WrenchIcon
            }
        });
    }

    async function getServices(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => services.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    onMounted(() => {
        if (skipLoading) return;

        getServices();
    });

    return {
        info,
        request,
        services,
        serviceOptions,
        getInfo,
        addService,
        getServices
    }
}